"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeBlockRequestsEventMap = exports.UnblockRequestsEvent = exports.BlockRequestsEvent = void 0;
const eventBusBasic_1 = require("../../eventBus/eventBusBasic");
var BaseBlockRequestsTypeMap;
(function (BaseBlockRequestsTypeMap) {
    BaseBlockRequestsTypeMap["BLOCK_REQUESTS"] = "BLOCK_REQUESTS";
    BaseBlockRequestsTypeMap["UNBLOCK_REQUESTS"] = "UNBLOCK_REQUESTS";
})(BaseBlockRequestsTypeMap || (BaseBlockRequestsTypeMap = {}));
class BlockRequestsEvent extends eventBusBasic_1.Event {
}
exports.BlockRequestsEvent = BlockRequestsEvent;
class UnblockRequestsEvent extends eventBusBasic_1.Event {
}
exports.UnblockRequestsEvent = UnblockRequestsEvent;
exports.TypeBlockRequestsEventMap = {
    [BaseBlockRequestsTypeMap.BLOCK_REQUESTS]: BlockRequestsEvent,
    [BaseBlockRequestsTypeMap.UNBLOCK_REQUESTS]: UnblockRequestsEvent,
};
//# sourceMappingURL=types.js.map